export default __webpack_public_path__ + "static/media/kapow.e52bf31b.png";